/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
import { getFirebaseBackend } from '../../../helpers/firebase_helper';
import {
  postFakeLogin,
  postJwtLogin,
  postOidcLogin,
  postSocialLogin,
} from '../../../helpers/fakebackend_helper';
import {
  loginSuccess,
  loginOidcSuccess,
  logoutUserSuccess,
  apiError,
  reset_login_flag,
  logoutOidcSuccess,
  showLoader,
  hideLoader,
} from './reducer';
import axios from 'axios';
import { api, web } from '../../../config';
import { userManager } from '../../../config/oidcConfig';
import { persistor } from '../../../store';
import { encryptAuthUser } from '../../../utils/crypto';
axios.defaults.withCredentials = true;
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';

// Login melalui Page
export const loginUser = (user, history) => async dispatch => {
  try {
    const response = await axios.post(
      `${api.API_URL}/account/login`,
      {
        username: user.username,
        password: user.password,
      },
      {
        withCredentials: true,
      }
    );
    if (response) {
      let apiData;
      if (response.data) {
        apiData = response.data;
      } else if (response.userName || response.email) {
        apiData = response;
      } else {
        console.error('Unexpected response structure:', response);
        throw new Error('Invalid API response structure');
      }
      if (!apiData) {
        throw new Error('No user data found in API response');
      }
      const authUser = await fetchauthUser(apiData.token);

      dispatch(loginSuccess(authUser));
      history('/dashboard');
    } else {
      throw new Error('Data Not Found');
    }
  } catch (error) {
    dispatch(apiError(error.message || 'Login failed'));
  }
};

export const idamanLogin = () => async dispatch => {
  try {
    dispatch(showLoader()); // Mulai loader
    await new Promise(resolve => setTimeout(resolve, 500)); // Jeda 500ms
    await userManager.signinRedirect();
  } catch (error) {
    console.error('Idaman Login Error :', error);
    dispatch(hideLoader()); // Matikan loader jika redirect gagal
    dispatch(apiError(error.message || 'Redirect to OIDC failed'));
  }
};

export const completeOidcLogin = navigate => async dispatch => {
  try {
    const oidcUser = await userManager.signinRedirectCallback();
    if (!oidcUser || !oidcUser.id_token) {
      throw new Error('Gagal mendapatkan token dari Identity Provider.');
    }
    const apiResponse = await postOidcLogin({ token: oidcUser.id_token });
    const userData = apiResponse?.data || apiResponse;
    if (!userData || !userData.token) {
      throw new Error(
        'Response dari server tidak valid. Data user atau token tidak ditemukan.'
      );
    }
    const authUser = await fetchauthUser(userData.token);

    dispatch(loginOidcSuccess(authUser));
    navigate('/dashboard');
  } catch (error) {
    console.error('OIDC Callback Error:', error);
    let userFriendlyMessage = 'Login gagal. Silakan coba lagi.';
    if (error.response) {
      if (error.response.status === 401 || error.response.status === 403) {
        userFriendlyMessage =
          'Autentikasi gagal. Periksa kembali kredensial Anda.';
      } else {
        userFriendlyMessage =
          error.response.data?.message || 'Terjadi kesalahan pada server.';
      }
    } else if (error.message) {
      if (
        error.message.includes('Identity Provider') ||
        error.message.includes('server tidak valid')
      ) {
        userFriendlyMessage = error.message;
      }
    }
    dispatch(apiError(userFriendlyMessage));
    navigate('/login');
  }
};

// Logout biasa (non-OIDC)
export const logoutUser = () => async dispatch => {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === 'firebase') {
      const fireBaseBackend = getFirebaseBackend();
      await fireBaseBackend.logout();
    }
    dispatch(logoutUserSuccess());
  } catch (error) {
    dispatch(apiError(error.message || 'Logout failed'));
  }
};

const handleLogout = async () => {
  // Tunggu clear selesai sebelum redirect
  await new Promise(resolve => {
    sessionStorage.clear();
    resolve();
  });
  window.location.href = '/login';
};

export const oidcLogout = () => async dispatch => {
  try {
    dispatch(logoutOidcSuccess()); // reset redux login state
    await persistor.purge(); // bersihkan redux-persist storage
    await userManager.signoutRedirect(); // redirect ke OIDC logout
  } catch (error) {
    dispatch(apiError(error.message || 'OIDC Logout failed'));
  }
};

// Callback setelah logout dari OIDC
export const oidcLogoutCallback = navigate => async dispatch => {
  try {
    await userManager.signoutRedirectCallback();
    dispatch(logoutOidcSuccess()); // ulangi reset state saat callback
    await persistor.purge(); // bersihkan redux-persist storage
    await userManager.signoutRedirect(); // redirect ke OIDC logout
    await userManager.clearStaleState(); // membersihkan data yang kadaluarsa
    await userManager.removeUser(); // menghapus user dari storage
    navigate('/'); // redirect ke halaman login
  } catch (error) {
    console.error('OIDC Logout Callback Error:', error);
    dispatch(apiError(error.message || 'Logout callback failed'));
    navigate('/error');
  }
};

// Login via Social (Firebase)
export const socialLogin = (type, history) => async dispatch => {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === 'firebase') {
      const fireBaseBackend = getFirebaseBackend();
      const response = await fireBaseBackend.socialLoginUser(type);
      if (response) {
        dispatch(loginSuccess(response, { meta: { isOidcUser: false } }));
        history('/dashboard');
      } else {
        throw new Error('Social login gagal');
      }
    }
  } catch (error) {
    dispatch(apiError(error.message || 'Social login failed'));
  }
};

export const resetLoginFlag = () => dispatch => {
  try {
    return dispatch(reset_login_flag());
  } catch (error) {
    dispatch(apiError(error.message || 'Reset login state failed'));
  }
};

const fetchauthUser = async token => {
  try {
    const response = await axios.get(`${api.API_URL}/account/my-profile`, {
      withXSRFToken: true,
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: `application/json`,
      },
    });
    let userData;
    userData = response;
    console.log(userData);
    const authUser = {
      email: userData.email,
      name: userData.userName,
      username: userData.userName,
      token: token,
      status: 'success',
      firstname: userData.firstname,
      role: userData?.roles?.join(', ') ?? 'No Role',
      photo: userData.photo,
      division: userData?.roles?.join(', ') ?? 'No Role',
      position: userData?.jobTitle ?? userData?.position ?? '',
      displayName: userData?.displayName ?? '',
    };
    const encryptedAuthUser = encryptAuthUser(authUser);
    sessionStorage.setItem('authUser', JSON.stringify(encryptedAuthUser));

    return authUser;
  } catch (error) {
    console.error('Error fetching data from Invoice API:', error);
  }
};
